import Swiper from 'swiper'

export function initGalleryCarousel() {
  const galleryCarousel = document.querySelector('[data-gallery-carousel]')

  if (!galleryCarousel) return

  const galleryPrev = galleryCarousel.querySelector('[data-carousel-prev]')
  const galleryNext = galleryCarousel.querySelector('[data-carousel-next]')

  const updateGalleryArrows = (instance) => {
    galleryPrev?.classList.toggle('is-disabled', instance.isBeginning)
    galleryNext?.classList.toggle('is-disabled', instance.isEnd)
  }

  const gallerySwiper = new Swiper(galleryCarousel.querySelector('.swiper'), {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    speed: 800,
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 1.2,
        spaceBetween: 32,
      },
    },
    on: {
      init: updateGalleryArrows,
      slideChange: updateGalleryArrows,
    },
  })

  galleryPrev?.addEventListener('click', () => gallerySwiper.slidePrev())
  galleryNext?.addEventListener('click', () => gallerySwiper.slideNext())
}
